import { useMutation } from '@tanstack/react-query';
import { IReport } from 'interfaces/PowerBi';
import { PowerBIEmbed } from 'powerbi-client-react';
import { useEffect, useState } from 'react';
import { models, Report, Embed, service } from 'powerbi-client';
import PowerBiApis from 'apis/PowerBiApis';
import Content from 'layouts/Content';
import { useTitle } from 'contexts/TitleProvider';
import { Spin } from 'antd';

interface IProps {
  myReport:
    | {
        groupId: string;
        reportId: string;
      }
    | any;
  title: any;
}

export const PowerBiComponent = (props: IProps) => {
  const { myReport, title } = props;
  const [report, setReport] = useState<Report>();
  const [displayMessage, setMessage] = useState(
    `The report is bootstrapped. Click the Embed Report button to set the access token`,
  );
  const { setTitle, setBreadcrumb } = useTitle();

  const {
    mutate: getToken,
    data: accessToken,
    isPending: isPending,
  } = useMutation<any>({
    mutationFn: (params: any) => PowerBiApis.getAccessToken(params),
    onSuccess: (res) => {
      console.log('Access token:', res);
    },
    onError: (error) => {
      console.error('Error:', error);
    },
  });

  useEffect(() => {
    getToken(myReport);
    setTitle(title);
    setBreadcrumb([{ title: 'Báo cáo' }, { title: title }]);
  }, [myReport]);

  const eventHandlersMap = new Map([
    [
      'loaded',
      function () {
        console.log('Report has loaded');
      },
    ],
    [
      'rendered',
      function () {
        console.log('Report has rendered');

        // Update display message
        setMessage('The report is rendered');
      },
    ],
    [
      'error',
      function (event?: service.ICustomEvent<any>) {
        if (event) {
          console.error(event.detail);
        }
      },
    ],
  ]);

  return (
    // <Spin spinning={isPending} size="large" style={{ maxHeight: '500px' }}>
    <div className="border-2 mt-2 h-[800px] w-full max-h-[82vh] bg-gray-200">
      {!isPending && (
        <PowerBIEmbed
          embedConfig={{
            type: 'report',
            embedUrl: accessToken?.embedUrl,
            id: myReport?.reportId,
            tokenType: models.TokenType.Aad,
            accessToken: accessToken?.access_token,
            settings: {
              panes: {
                filters: {
                  expanded: false,
                  visible: false,
                },
              },
              background: models.BackgroundType.Transparent,
            },
          }}
          eventHandlers={eventHandlersMap}
          cssClassName={
            'border-2 mt-2 h-[800px] w-full max-h-[82vh] bg-gray-200'
          }
          getEmbeddedComponent={(embedObject: Embed) => {
            console.log(
              `Embedded object of type "${embedObject.embedtype}" received`,
            );
            setReport(embedObject as Report);
          }}
        />
      )}
    </div>
    // </Spin>
  );
};
